module.exports = __webpack_public_path__ + "static/media/positiveMaxPowermeter.6c767fef.svg";